var map = {
	"./3-steps-to-meaningful-motion-design.mdx": [
		215,
		18
	],
	"./accessible-motion-design-for-the-web.mdx": [
		216,
		19
	],
	"./modern-ux-with-react-server-components.mdx": [
		217,
		20
	],
	"./observer-api-for-modern-javascript.mdx": [
		218,
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 211;
module.exports = webpackAsyncContext;